@if ({
  viewMode: currentViewMode$ | async,
  otherOption: otherOption$ | async,
  }; as content) {
  <button
    class="btn cx-product-layout"
    (click)="changeMode()"
    tabindex="0"
    attr.aria-label="{{ 'productView.' + content.otherOption + 'View' | cxTranslate }}"
    title="{{ 'productView.' + content.otherOption + 'View' | cxTranslate }}"
    >
    @if (content.viewMode?.toString()?.toUpperCase() === ICON_TYPE.GRID) {
      <cx-icon [type]="ICON_TYPE.LIST"></cx-icon>
    }
    @if (content.viewMode?.toString()?.toUpperCase() === ICON_TYPE.LIST) {
      <cx-icon [type]="ICON_TYPE.GRID"></cx-icon>
    }
  </button>
}
